export enum StreamStatusEnum {
    PENDING = 0,
    IN_PROGRESS = 1,
    CLOSED = 2
}

export enum userStreamStatusEnum {
  RECENTLY_VIEWD = 1
}